module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"novelty":"Nouveau"},"en":{"novelty":"New"},"de":{"novelty":"Neu"},"es":{"novelty":"Nuevo"},"it":{"novelty":"Nuovo"},"nl":{"novelty":"nieuw"},"pt":{"novelty":"Novo"}}')
  delete Component.options._Ctor
}
